import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { Link } from 'react-router-dom';
import CpdActivitiesSIDEbar from './CpdActivitiesSIDEbar'
import appformNotqualified from '../assets/pdf/Application Form_EPE_for Not Qualified Candidates.docx';
import appformNew from '../assets/pdf/Application Form for New EPE Applicants.docx';

class EPEForms extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [{
        name: "Short Courses Presentation by PEC",
        url: "/ShortCoursesPPT"
      },
      {
        name: "Forms",
       
        type:"button",
        "child":[
          {
            name: "CPD Resourse Person Allocation Form",
            url: "/CPD_Resource_person",
          },
          {
            name: "EPE Applicatin Forms ",
            url: "/EPEForms",
          },
          {
            name: "PEB Application Form",
            url: "/CPDForms",
          }
        ]
      },
      {
        name: "Documents",
        url: "/Documents"
      }
      ]
      }
  }
  componentDidMount(){
    document.title = "Forms";
}
render() {
  return (
    <React.Fragment>
      <section  className="backco_white" style={{ fontFamily: 'Arial' }}>
        <Header />
        <div className="row col_margin">
          <div className="col-md-3 col_padding" style={{ padding: '2%' }}>
          <CpdActivitiesSIDEbar data={this.state.data} />
          </div>
          <div className="col-md-7 col_padding intr_mr">
            <h2 className="text-center" style={{ margin: '28px 0px 0px 1px' }}>EPE Application Forms</h2>
            <div className="row">
               <div className="col-md-12" col_padding style={{ padding: '2%', paddingTop: "0px" }}>
              <div className="into-p">
                  <p>
                To Download EPE Application Form, Click below!</p>
                </div>
                <i className="far fa-file-pdf fa-1x co_black bold"></i>&nbsp;
                <b className="pdf_text">Not_Qualified_Candidates</b>&nbsp;&nbsp;
                <Link to={appformNotqualified} className="btn btn-success bold font_sans fz_14"
                  target="_blank" download>Download</Link>
                  <br/> <br/>
                  <i className="far fa-file-pdf fa-1x co_black bold"></i>&nbsp;
                <b className="pdf_text">New_Applicants</b>&nbsp;&nbsp;
                <Link to={appformNew} className="btn btn-success bold font_sans fz_14"
                  target="_blank" download>Download</Link>
              </div>
            </div>
          </div>
          <div className="col-md-1">
          </div>
        </div>
        {/*<Footer/>*/}
      </section>
    </React.Fragment>
    );
  }
}
export default EPEForms;